import React from "react";
import microphoneIcon from "@public/img/microphone.svg";
import subtitleIcon from "@public/img/subtitle.svg";
import imdbIcon from "@public/img/imdb.svg";
import calendarIcon from "@public/img/calendar.svg";
import { ASSETS_BASE_URL } from "../../utils/constants";
import { Link } from "react-router-dom";
import LazyPosterImage from "./lazy-poster-image";
import "@/styles/movie-card.css";

export type MovieCardProps = {
  id: number;
  slug: string;
  type: string;
  title: string;
  updateText: string;
  year: string;
  ratingValue: string;
  thumbnail: string;
  isDubbed: boolean;
  isSubtitled: boolean;
  genres: string[];
  rootClassName?: string;
  eagerLoad?: boolean;
};

function MovieCard({
  id,
  slug,
  type,
  title,
  updateText,
  year,
  ratingValue,
  thumbnail,
  isDubbed,
  isSubtitled,
  genres,
  rootClassName,
  eagerLoad,
}: MovieCardProps) {
  const posterSrc =
    thumbnail && thumbnail.indexOf("http") === 0
      ? thumbnail
      : ASSETS_BASE_URL + (thumbnail ? thumbnail : "");

  return (
    <Link to={`/${type}/${id}/${slug}/`} target="_blank" className="movie-card-link">
      <article className={"movie-card rtl" + (rootClassName ? " " + rootClassName : "")}>
        <div className="movie-card__poster">
          <LazyPosterImage
            src={posterSrc}
            alt={title}
            className="movie-card__image"
            width={180}
            height={270}
            eager={eagerLoad === true}
          />
          <div className="movie-card__gradient" />

          <div className="movie-card__badges">
            {isDubbed && (
              <img
                src={microphoneIcon}
                alt={`دانلود فیلم ${title} با دوبله فارسی`}
                className="movie-card__badge-dubbed"
              />
            )}

            {isSubtitled && (
              <img
                src={subtitleIcon}
                alt={`دانلود فیلم ${title} با زیرنویس فارسی`}
              />
            )}
          </div>

          <div className="movie-card__hover">
            <div className="movie-card__genres">
              {genres.map((genre) => (
                <span key={genre}>{genre}</span>
              ))}
            </div>
          </div>

          <div className="movie-card__meta">
            <div className="movie-card__meta-year">
              <img src={calendarIcon} alt="" />
              <span>{year}</span>
            </div>

            <div className="movie-card__meta-rating">
              <span>
                {ratingValue == "0" ? (
                  "N/A"
                ) : (
                  <>
                    <span className="movie-card__rating-denom">10/</span> {ratingValue}
                  </>
                )}
              </span>
              <img src={imdbIcon} alt="" />
            </div>
          </div>
        </div>

        <div className="movie-card__info">
          <h2 className="movie-card__title" dir="auto">
            {title}
          </h2>
          <p className="movie-card__subtitle" dir="auto">
            {updateText}
          </p>
        </div>
      </article>
    </Link>
  );
}

export default MovieCard;
